import type { OnboardingEmailChangeDocument } from './onboarding-email-change.model';

export interface GenerateOnboardingEmailChangeEligibilityObjectOptions {
  readonly id: string;
  readonly email: string;
  readonly isEligible?: boolean;
}

export function generateOnboardingEmailChangeEligibilityObject({
  id,
  email,
  isEligible,
}: GenerateOnboardingEmailChangeEligibilityObjectOptions): OnboardingEmailChangeDocument {
  return {
    id,
    email,
    isEligible,
  };
}
